
import { useState, useEffect } from 'react';
import { useSnackbar } from "notistack";
import { Table, Checkbox, TableCell, TableRow, TableHead, TableBody, Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress, Chip } from '@mui/material'
import useTableSortingHook from '../hooks/useTableSortingHook';
import { NoRecordFound, PageLoader, STableLoader } from '../../../shared_elements';
import { checkApiStatus } from '../../../utils';
import { addLlpApi, getAddLllpListApi } from '../apiServices';
import { globalGetService, globalPostService } from '../../../utils/globalApiServices';
import { trackActivity } from '../../../utils/mixpanel';

const LLPAddHd = ({ toggleBulkOps, tableSorting, item, bulk, }) => {
  return (
    <TableHead>
      <TableRow >
        <TableCell sx={{ position: 'sticky', left: 0, backgroundColor: '#e6ecff', zIndex: 11, }}>
          <Checkbox
            color='primary'
            size='small'
            onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)}
            checked={item?.length === bulk?.ids?.length && item?.length > 0}
          />
        </TableCell>
        <TableCell >Module</TableCell>
        <TableCell sx={{width :"180px"}} >Description</TableCell>
        <TableCell>Part Number</TableCell>
        <TableCell>Cycles Remaining</TableCell>
      </TableRow>
    </TableHead>
  );
};
const LLPAddModal = ({ getResponseBack, addLLP, modeType, onToggleModal, shopVisit }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [queryConfig, setQueryConfig] = useState({
    page: 1,
    per_page: 20,
  });
  const [llpAddInfo, setLlpAddInfo] = useState({ list: [], pagination: {} })
  const [isLoading, setLoading] = useState({ skeletonLoader: false, pageLoader: false, buttonLoader: false });
  const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
  const isSameItem = (a, b) => a?.id === b?.id && !!a?.is_non_llp === !!b?.is_non_llp
  const toggleBulkOps = (flag, type, item) => {
    if (type === 'bulk') {
      setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] })
    } else {
      setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk?.ids?.filter(optionItem => !isSameItem(optionItem, item)) })
    }
  }
  const toggleLoader = (type, status) => { setLoading({ [type]: status }) }
  const getLLPList = (query = {}, loaderType) => {
    loaderType === 'skeletonLoader' ? toggleLoader("skeletonLoader", true) : toggleLoader("pageLoader", true);
    globalGetService(getAddLllpListApi(shopVisit?.asset_id, { ...query, shop_visit_id: shopVisit?.id }), {}).then(response => {
      if (checkApiStatus(response)) {
        const { llp = [], non_llp = [], pagination = {} } = response?.data?.data || {};
        const list = [
          ...llp.map(item => ({ ...item, is_non_llp: false })),
          ...non_llp.map(item => ({ ...item, module: item?.module?.name ?? item?.module, cycles_remaining: item?.remaining_cycle, is_non_llp: true, })),
        ];
        setLlpAddInfo({ list, pagination });
      }
      loaderType === 'skeletonLoader' ? toggleLoader("skeletonLoader", false) : toggleLoader("pageLoader", false);
    });
  };
  const createSortHandler = (key) => {
    const isAsc = queryConfig.sort_by === key && queryConfig.sort === 'asc';
    const updatedSort = isAsc ? 'desc' : 'asc';
    setQueryConfig({
      sort_by: key,
      sort: updatedSort
    });
    getLLPList({
      sort: updatedSort,
      sort_by: key,
    });
  };
  const checkedLlpList = bulk?.ids?.filter(item => !item.is_non_llp)?.map(item => item.id)
  const checkedNonLlpList = bulk?.ids?.filter(item => item.is_non_llp)?.map(item => item.id)
  const onAddLLP = () => {
    setLoading({buttonLoader : true})
    const payload = { shop_visit_id: shopVisit?.id, llp_list: checkedLlpList, non_llp_list: checkedNonLlpList }
    globalPostService(addLlpApi(shopVisit?.asset_id), payload).then(async (response) => {
      if (checkApiStatus(response)) {
        setLoading({buttonLoader : true})
        onToggleModal()
        getResponseBack()
        trackActivity('Item Added', { page_title: `Add Shop Visit LLP`, success_msg: response?.data?.message, item_id: shopVisit?.id, payload: payload, response: response?.data })
      } else {
        setLoading({buttonLoader :false,});
        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
        trackActivity('Item Added', { page_title: `Add Shop Visit LLP`, error_msg: response?.data?.message, item_id: shopVisit?.id, payload: payload, response: response?.data })
      }
    });
  }
  const { tableSorting } = useTableSortingHook(queryConfig, createSortHandler)

  useEffect(() => {
    if (shopVisit?.id && shopVisit?.asset_id) { getLLPList(queryConfig, "skeletonLoader") }
  }, [])
const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Shop Visit Add LLP`, page_type: page_type, })
    }
  return (
    <>
      <Dialog
        aria-labelledby="customized-dialog-title"
        className='add-lease-dialog'
        maxWidth='md'
        fullWidth
        open={addLLP?.modal}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>Add LLP</DialogTitle>
        <DialogContent dividers>
          {isLoading?.skeletonLoader ? <STableLoader count={4} rowCount={5} /> : <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <Table className='mui-table-format' stickyHeader>
              <LLPAddHd item={llpAddInfo?.list} toggleBulkOps={toggleBulkOps} bulk={bulk} tableSorting={tableSorting} />
              <TableBody>
                <>
                  {llpAddInfo?.list?.length > 0 && llpAddInfo?.list?.map((item, index) => {
                    return (
                      <TableRow key={`${item?.is_non_llp ? 'non_llp' : 'llp'}-${item?.id}`}>
                        <TableCell sx={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 8, }}>
                          <Checkbox color='primary' size='small'
                            checked={bulk?.ids.find(items => isSameItem(items, item)) ? true : false}
                            onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                          />
                        </TableCell>
                        <TableCell >
                          {item?.module ?? "--"}
                          {item?.is_non_llp ? <Chip label="Non LLP" size="small" variant="outlined" sx={{ ml: 1, fontSize: '0.7rem', height: '18px', width: '60px', background: '#ebebeb' }} /> : null}
                        </TableCell>
                        <TableCell >{item?.description ?? "--"}</TableCell>
                        <TableCell >{item?.part_number ?? "--"}</TableCell>
                        <TableCell >{item?.cycles_remaining ?? "--"}</TableCell>
                      </TableRow>
                    )})}
                </>
              </TableBody> </Table>
              {!llpAddInfo?.list?.length && <NoRecordFound />}
          </div>}
          {isLoading?.pageLoader ? <PageLoader /> : null}
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' size='small' disabled={isLoading?.buttonLoader} onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Cancel </Button>
          <Button variant='contained' className='btn-primary' disabled={modeType === 'view' || !bulk?.ids?.length} size='small' onClick={() => { onAddLLP(); handleItemClicked('Save Button') }}>
            {isLoading?.buttonLoader ? <CircularProgress color='inherit' size={25} /> : "Save"}
          </Button>
        </DialogActions>

      </Dialog>


    </>
  )
}

export default LLPAddModal